import LessonApiUtils from '../utils/api/lesson';

export const FETCH_LESSON_SENT = 'FETCH_LESSON_SENT';
export const FETCH_LESSON_SUCCEEDED = 'FETCH_LESSON_SUCCEEDED';
export const FETCH_LESSON_FAILED = 'FETCH_LESSON_FAILED';
export const FETCH_STUDENT_LESSONS_SENT = 'FETCH_STUDENT_LESSONS_SENT';
export const FETCH_STUDENT_LESSONS_SUCCEEDED =
  'FETCH_STUDENT_LESSONS_SUCCEEDED';
export const FETCH_STUDENT_LESSONS_FAILED = 'FETCH_STUDENT_LESSONS_FAILED';
export const FETCH_MY_LESSONS_SENT = 'FETCH_MY_LESSONS_SENT';
export const FETCH_MY_LESSONS_SUCCEEDED = 'FETCH_MY_LESSONS_SUCCEEDED';
export const FETCH_MY_LESSONS_FAILED = 'FETCH_MY_LESSONS_FAILED';
export const FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SENT =
  'FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SENT';
export const FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED =
  'FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED';
export const FETCH_MY_LESSONS_WITH_OPEN_ISSUE_FAILED =
  'FETCH_MY_LESSONS_WITH_OPEN_ISSUE_FAILED';
export const FETCH_TUTOR_LESSONS_SENT = 'FETCH_TUOTR_LESSONS_SENT';
export const FETCH_TUTOR_LESSONS_SUCCEEDED = 'FETCH_TUOTR_LESSONS_SUCCEEDED';
export const FETCH_TUTOR_LESSONS_FAILED = 'FETCH_TUOTR_LESSONS_FAILED';
export const FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_SENT =
  'FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_SENT';
export const FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED =
  'FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED';
export const FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_FAILED =
  'FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_FAILED';
export const MARK_LESSON_AS_SKIPPED_BY_TUTOR_SENT =
  'MARK_LESSON_AS_SKIPPED_BY_TUTOR_SENT';
export const MARK_LESSON_AS_SKIPPED_BY_TUTOR_SUCCEEDED =
  'MARK_LESSON_AS_SKIPPED_BY_TUTOR_SUCCEEDED';
export const MARK_LESSON_AS_SKIPPED_BY_TUTOR_FAILED =
  'MARK_LESSON_AS_SKIPPED_BY_TUTOR_FAILED';
export const GET_MY_LESSON_SIZE_SENT = 'GET_MY_LESSON_SIZE_SENT';
export const GET_MY_LESSON_SIZE_SUCCEEDED = 'GET_MY_LESSON_SIZE_SUCCEEDED';
export const GET_MY_LESSON_SIZE_FAILED = 'GET_MY_LESSON_SIZE_FAILED';

export function fetchOneSent() {
  return { type: FETCH_LESSON_SENT };
}

export function fetchOneSucceeded(data) {
  return {
    type: FETCH_LESSON_SUCCEEDED,
    payload: data,
  };
}

export function fetchOneFailed(error) {
  return {
    type: FETCH_LESSON_FAILED,
  };
}

export function fetchOne(id) {
  return (dispatch) => {
    return LessonApiUtils.fetchOne(id).then(
      (data) => dispatch(fetchOneSucceeded(data)),
      (error) => dispatch(fetchOneFailed(error)),
    );
  };
}

export function fetchStudentLessonsSent(page) {
  return {
    type: FETCH_STUDENT_LESSONS_SENT,
    payload: { page },
  };
}

export function fetchStudentLessonsSucceeded(data) {
  return {
    type: FETCH_STUDENT_LESSONS_SUCCEEDED,
    payload: data,
  };
}

export function fetchStudentLessonsFailed(error) {
  return {
    type: FETCH_STUDENT_LESSONS_FAILED,
  };
}

export function fetchStudentLessons(studentId, page = 1, tutorId = null) {
  return (dispatch) => {
    dispatch(fetchStudentLessonsSent(page));
    return LessonApiUtils.fetchStudentLessons(studentId, page, tutorId).then(
      (data) => dispatch(fetchStudentLessonsSucceeded(data)),
      (error) => dispatch(fetchStudentLessonsFailed(error)),
    );
  };
}

// export function fetchMyLessonsWithOpenIssueSent() {
//   return { type: FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SENT }
// }
//
// export function fetchMyLessonsWithOpenIssueSucceeded(data) {
//   return {
//     type: FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED,
//     payload: data
//   }
// }
//
// export function fetchMyLessonsWithOpenIssueFailed(error) {
//   return {
//     type: FETCH_MY_LESSONS_WITH_OPEN_ISSUE_FAILED
//   }
// }
//
// export function fetchMyLessonsWithOpenIssue(page=1) {
//   return (dispatch) => {
//     dispatch(fetchMyLessonsWithOpenIssueSent());
//     return LessonApiUtils.fetchStudentLessonsWithOpenIssue(page).then(
//       (data) => dispatch(fetchMyLessonsWithOpenIssueSucceeded(data)),
//       (error) => dispatch(fetchMyLessonsWithOpenIssueFailed(error))
//     );
//   };
// }

export function fetchTutorLessonsSent() {
  return { type: FETCH_TUTOR_LESSONS_SENT };
}

export function fetchTutorLessonsSucceeded(data) {
  return {
    type: FETCH_TUTOR_LESSONS_SUCCEEDED,
    payload: data,
  };
}

export function fetchTutorLessonsFailed(error) {
  return {
    type: FETCH_TUTOR_LESSONS_FAILED,
  };
}

export function fetchTutorLessons(tutorId, page = 1, studentId = null) {
  return (dispatch) => {
    dispatch(fetchTutorLessonsSent());
    return LessonApiUtils.fetchTutorLessons(studentId, page, tutorId).then(
      (data) => dispatch(fetchTutorLessonsSucceeded(data)),
      (error) => dispatch(fetchTutorLessonsFailed(error)),
    );
  };
}

export function fetchTutorLessonsWithOpenIssueSent() {
  return { type: FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_SENT };
}

export function fetchTutorLessonsWithOpenIssueSucceeded(data) {
  return {
    type: FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED,
    payload: data,
  };
}

export function fetchTutorLessonsWithOpenIssueFailed(error) {
  return {
    type: FETCH_TUTOR_LESSONS_WITH_OPEN_ISSUE_FAILED,
  };
}

export function fetchTutorLessonsWithOpenIssue(page = 1) {
  return (dispatch) => {
    dispatch(fetchTutorLessonsWithOpenIssueSent());
    return LessonApiUtils.fetchTutorLessonsWithOpenIssue(page).then(
      (data) => dispatch(fetchTutorLessonsWithOpenIssueSucceeded(data)),
      (error) => dispatch(fetchTutorLessonsWithOpenIssueFailed(error)),
    );
  };
}

export function fetchMyLessonsSent(page) {
  return {
    type: FETCH_MY_LESSONS_SENT,
    payload: { page },
  };
}

export function fetchMyLessonsSucceeded(data) {
  return {
    type: FETCH_MY_LESSONS_SUCCEEDED,
    payload: data,
  };
}

export function fetchMyLessonsFailed(error) {
  return {
    type: FETCH_MY_LESSONS_FAILED,
  };
}

export function fetchMyLessons(page = 1, otherUserId = null) {
  return (dispatch) => {
    dispatch(fetchMyLessonsSent(page));
    return LessonApiUtils.fetchMyLessons(page, [4, 5, 6, 7], otherUserId).then(
      (data) => dispatch(fetchMyLessonsSucceeded(data)),
      (error) => dispatch(fetchMyLessonsFailed(error)),
    );
  };
}

export function fetchMyLessonsWithOpenIssueSent(page) {
  return {
    type: FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SENT,
    payload: { page },
  };
}

export function fetchMyLessonsWithOpenIssueSucceeded(data) {
  return {
    type: FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED,
    payload: data,
  };
}

export function fetchMyLessonsWithOpenIssueFailed(error) {
  return {
    type: FETCH_MY_LESSONS_WITH_OPEN_ISSUE_FAILED,
  };
}

export function fetchMyLessonsWithOpenIssue(page = 1, otherUserId = null) {
  return (dispatch) => {
    dispatch(fetchMyLessonsWithOpenIssueSent(page));
    return LessonApiUtils.fetchMyLessons(page, [5], otherUserId).then(
      (data) => dispatch(fetchMyLessonsWithOpenIssueSucceeded(data)),
      (error) => dispatch(fetchMyLessonsWithOpenIssueFailed(error)),
    );
  };
}

export function getMyLessonSizeSent() {
  return { type: GET_MY_LESSON_SIZE_SENT };
}

export function getMyLessonSizeSucceeded(data) {
  return {
    type: GET_MY_LESSON_SIZE_SUCCEEDED,
    payload: data,
  };
}

export function getMyLessonSizeFailed(error) {
  return {
    type: GET_MY_LESSON_SIZE_FAILED,
  };
}

export function getMyLessonSize(id) {
  return (dispatch) => {
    dispatch(getMyLessonSizeSent());
    return LessonApiUtils.getMyLessonSize(id).then(
      (data) => dispatch(getMyLessonSizeSucceeded(data)),
      (error) => dispatch(getMyLessonSizeFailed(error)),
    );
  };
}

export function markAsSkippedByTutorSent() {
  return { type: MARK_LESSON_AS_SKIPPED_BY_TUTOR_SENT };
}

export function markAsSkippedByTutorSucceeded(data) {
  return {
    type: MARK_LESSON_AS_SKIPPED_BY_TUTOR_SUCCEEDED,
    payload: data,
  };
}

export function markAsSkippedByTutorFailed(error) {
  return {
    type: MARK_LESSON_AS_SKIPPED_BY_TUTOR_FAILED,
  };
}

export function markAsSkippedByTutor(lessonId) {
  return (dispatch) => {
    dispatch(markAsSkippedByTutorSent());
    return LessonApiUtils.markAsSkippedByTutor(lessonId).then(
      (data) => dispatch(markAsSkippedByTutorSucceeded(data)),
      (error) => dispatch(markAsSkippedByTutorFailed(error)),
    );
  };
}
